import styles from './AppStatus.module.scss'

const AppStatus = ({ text, color }) => {
  return (
    <p className={`${styles.status} ${styles[color] || ''}`}>
      <span></span>
      {text}
    </p>
  )
}

export default AppStatus
